/* TD Bottom Glass Search V1.3 — visual trigger for existing header search. */
(function () {
  'use strict';
  var bar = document.querySelector('[data-td-bottom-glass-search]');
  if (!bar || !window.matchMedia) return;
  var mobile = window.matchMedia('(max-width: 1024px)');
  var prompt = bar.querySelector('[data-td-glass-prompt]');
  var searchButton = bar.querySelector('[data-td-bottom-glass-trigger]');
  var homeLink = bar.querySelector('.td-bottom-glass-search__home');
  var cartLink = bar.querySelector('.td-bottom-glass-search__action');
  var ordersLink = bar.querySelector('.td-bottom-glass-search__orders');
  var liveLink = bar.querySelector('[data-td-bottom-glass-live]');
  var header = document.querySelector('.site-header__search-container predictive-search[data-context="header"]');
  var headerInput = header && header.querySelector('.search__input');
  var trigger = document.querySelector('.js-search-header');
  var headerContainer = header && header.closest('.site-header__search-container');
  var headerClose = header && header.querySelector('.btn--close-search');
  var closeLabel = bar.getAttribute('data-td-glass-close') || 'Close';
  var searchAriaLabel = searchButton.getAttribute('aria-label');
  if (!headerInput || !trigger || !headerClose || !prompt || !searchButton || !homeLink || !cartLink || !ordersLink || !liveLink) return;

  // No duplicate metaobject fetch, polling or independent LIVE detection.
  // The existing notice detector reports its verified source once per page load.
  window.addEventListener('td:live-source-resolved', function (event) {
    var id = event.detail && String(event.detail.liveId || '');
    var active = /^\d+$/.test(id);
    liveLink.hidden = !active;
    if (active) liveLink.href = 'https://www.facebook.com/tdpajamas/videos/' + id + '/';
    else liveLink.removeAttribute('href');
    schedule();
  });

  // Reuse header Search V7.1's EN/VI hint strings and 8s cadence.
  // One persistent text node avoids blank frames from independent CSS animations on iOS.
  var query = (bar.getAttribute('data-search-term') || '').trim();
  var hintNode = prompt.querySelector('.td-bottom-glass-search__hint') || prompt;
  var hints = [];
  var hintIndex = 0;
  var hintTimer = 0;
  if (query) {
    hintNode.textContent = query;
    searchButton.setAttribute('aria-label', (searchButton.getAttribute('aria-label') || 'Search') + ': ' + query);
  } else {
    try { hints = JSON.parse(bar.getAttribute('data-td-glass-hints') || headerInput.getAttribute('data-rotate') || '[]'); } catch (e) {}
    if (!Array.isArray(hints)) hints = [];
    hints = hints.filter(function (hint) { return typeof hint === 'string' && hint.trim(); }).slice(0, 7);
    if (hints.length) hintNode.textContent = hints[0];
  }
  hintNode.classList.toggle('td-bottom-glass-search__hint--long', !query && hints.length > 0 && hints[0].length > 26);
  searchAriaLabel = searchButton.getAttribute('aria-label');
  function startHints() {
    if (hintTimer || query || hints.length < 2 || document.hidden) return;
    hintTimer = window.setInterval(function () {
      if (!bar.isConnected || document.hidden) return;
      hintIndex = (hintIndex + 1) % hints.length;
      hintNode.textContent = hints[hintIndex];
      hintNode.classList.toggle('td-bottom-glass-search__hint--long', hints[hintIndex].length > 26);
    }, 8000);
  }
  function stopHints() {
    if (hintTimer) window.clearInterval(hintTimer);
    hintTimer = 0;
  }
  startHints();

  // Existing Impulse CartDrawer updates the raw .cart-link__bubble-num node.
  // Observe only that node; never fetch cart data or modify its source count.
  var cartCountNode = cartLink.querySelector('.cart-link__bubble-num');
  var cartCountDisplay = cartLink.querySelector('.td-bottom-glass-search__cart-display');
  if (cartCountNode && cartCountDisplay) {
    function syncCartBadge() {
      var count = Number(cartCountNode.textContent.trim());
      if (!Number.isFinite(count) || count < 0) return;
      count = Math.floor(count);
      cartCountDisplay.textContent = count > 99 ? '99+' : String(count);
      var label = cartLink.getAttribute('data-cart-base-label') || 'Cart';
      if (count) {
        var noun = cartLink.getAttribute(count === 1 ? 'data-cart-item-label' : 'data-cart-items-label') || '';
        label += ', ' + count + (noun ? ' ' + noun : '');
      }
      cartLink.setAttribute('aria-label', label);
    }
    var cartCountWatcher = new MutationObserver(syncCartBadge);
    cartCountWatcher.observe(cartCountNode, { childList: true, characterData: true, subtree: true });
    syncCartBadge();
  }

  var lastY = Math.max(0, window.scrollY || window.pageYOffset || 0);
  var direction = 0;
  var directionStart = lastY;
  var scrollHidden = false;
  var raf = 0;
  var idleTimer = 0;
  var idleDelay = 1200; // Scroll stopped: reappear without changing Messenger/BTT behavior.
  var noticeHoldUntil = 0;
  var noticeHoldTimer = 0;

  function visibleElement(selector) {
    var nodes = document.querySelectorAll(selector);
    for (var i = 0; i < nodes.length; i++) {
      var node = nodes[i];
      if (node.hidden) continue;
      var style = getComputedStyle(node);
      if (style.display === 'none' || style.visibility === 'hidden' || parseFloat(style.opacity) <= 0) continue;
      var r = node.getBoundingClientRect();
      if (r.width > 1 && r.height > 1 && r.bottom > 0 && r.top < innerHeight) return true;
    }
    return false;
  }

  function isBlocked() {
    var html = document.documentElement;
    var body = document.body;
    if (document.hidden || !mobile.matches || (window.visualViewport && window.visualViewport.scale > 1.01) ||
        Date.now() < noticeHoldUntil) return true;
    if (html.classList.contains('js-drawer-open') || html.classList.contains('js-drawer-closing') ||
        html.classList.contains('td-ps-open') || html.classList.contains('td-float-msg-modal-open') ||
        html.classList.contains('td-variant-prompt-open') || html.classList.contains('td-live-notice-visible') ||
        html.classList.contains('modal-open') || html.classList.contains('modal-closing')) return true;
    if (body && (body.classList.contains('predictive-overflow-hidden') || body.classList.contains('drawer-open') ||
        body.classList.contains('menu-open') || body.classList.contains('search-open'))) return true;
    if (window.TDNoticeQueue && window.TDNoticeQueue.current()) return true;
    var active = document.activeElement;
    if (active && active.matches && active.matches('input, textarea, select, [contenteditable="true"]')) return true;
    return visibleElement('#CartDrawer.drawer--is-open, #WishlistDrawer.drawer--is-open, '
      + '.site-header__search-container.is-active, predictive-search.is-active, '
      + '.modal.modal--is-active, .td-variant-prompt-root.is-active, [data-td-float-msg-modal].is-show, '
      + '[data-td-simple-lang] details[open], .td-simple-lang--hint-visible [data-td-simple-lang-hint], '
      + '.td-live-notice.is-visible:not(.is-obscured), .td-saved-items-reminder.is-show, '
      + '#td-refresh-hint, #td-urgency-root .td-urgency--show, [data-td-float-msg-hint].is-show, '
      + '#td-exit-overlay[style*="flex"]');
  }

  function backToTopOverlaps() {
    var btt = document.getElementById('BackToTop');
    if (!btt || btt.classList.contains('hide')) return false;
    var s = getComputedStyle(btt);
    if (s.display === 'none' || s.visibility === 'hidden') return false;
    var r = btt.getBoundingClientRect();
    var b = bar.getBoundingClientRect();
    var gap = 8;
    return r.width > 10 && r.height > 10 && r.left < b.right + gap &&
      r.right > b.left - gap && r.top < b.bottom + gap && r.bottom > b.top - gap;
  }

  function messengerOverlaps() {
    // Messenger remains fully draggable; do not rewrite its drag/clamp controller.
    var messenger = document.querySelector('[data-td-float-msg]');
    if (!messenger || messenger.classList.contains('is-hidden')) return false;
    var m = messenger.getBoundingClientRect();
    var b = bar.getBoundingClientRect();
    var gap = 8;
    return m.width > 10 && m.height > 10 && m.left < b.right + gap &&
      m.right > b.left - gap && m.top < b.bottom + gap && m.bottom > b.top - gap;
  }

  function headerSearchIsOpen() {
    return !!(headerContainer && headerContainer.classList.contains('is-active') &&
      header.classList.contains('is-active') && document.documentElement.classList.contains('td-ps-open'));
  }

  var nativeCloseFallback = false; // Reset only after search closes; avoids retry/observer loops.
  function sync() {
    raf = 0;
    var html = document.documentElement;
    var searchOpen = headerSearchIsOpen();
    if (!searchOpen) nativeCloseFallback = false;
    // Existing native X is the fallback if the bottom Close cannot be safely shown.
    var competing = html.classList.contains('js-drawer-open') ||
      html.classList.contains('js-drawer-closing') ||
      html.classList.contains('modal-open') ||
      html.classList.contains('td-float-msg-modal-open') ||
      html.classList.contains('td-variant-prompt-open') ||
      visibleElement('#CartDrawer.drawer--is-open, #WishlistDrawer.drawer--is-open, .modal.modal--is-active');
    var show = searchOpen
      ? !document.hidden && mobile.matches && !competing && !nativeCloseFallback
      : !scrollHidden && !isBlocked() && !messengerOverlaps() && !backToTopOverlaps();
    searchButton.setAttribute('aria-label', searchOpen ? closeLabel : searchAriaLabel);
    var keyboardOffset = 0;
    if (searchOpen && window.visualViewport && window.visualViewport.scale <= 1.01) {
      var viewport = window.visualViewport;
      keyboardOffset = Math.max(0, Math.ceil(window.innerHeight - viewport.height - viewport.offsetTop));
      if (keyboardOffset < 140) keyboardOffset = 0; // Browser chrome changes are not a keyboard.
    }
    bar.style.setProperty('--td-glass-keyboard-offset', keyboardOffset + 'px');
    bar.classList.toggle('is-search-close', searchOpen && show);
    html.classList.toggle('td-glass-close-open', searchOpen && show);
    // Measure AFTER enabling the compact mode, so keyboard offset and pill size are exact.
    if (searchOpen && show) {
      var results = header.querySelector('.search__results');
      var space = results ? Math.floor(bar.getBoundingClientRect().top - results.getBoundingClientRect().top - 12) : 0;
      if (space >= 110) html.style.setProperty('--td-glass-close-results-max-height', space + 'px');
      else { show = false; nativeCloseFallback = true; } // Too short: keep original X accessible.
    }
    if (!show || !searchOpen) html.style.removeProperty('--td-glass-close-results-max-height');
    if (!show) {
      html.classList.remove('td-glass-close-open');
      bar.classList.remove('is-search-close');
    }
    bar.classList.toggle('is-visible', show);
    // Verify stacking after applying the close state; never hide native X behind a covered pill.
    if (searchOpen && show) {
      var r = bar.getBoundingClientRect();
      var topElement = document.elementFromPoint(r.left + r.width / 2, r.top + r.height / 2);
      if (!topElement || !bar.contains(topElement)) {
        show = false;
        nativeCloseFallback = true;
        html.classList.remove('td-glass-close-open');
        html.style.removeProperty('--td-glass-close-results-max-height');
        bar.classList.remove('is-search-close', 'is-visible');
      }
    }
    bar.setAttribute('aria-hidden', show ? 'false' : 'true');
    searchButton.tabIndex = show ? 0 : -1;
    homeLink.tabIndex = show && !searchOpen ? 0 : -1;
    cartLink.tabIndex = show && !searchOpen ? 0 : -1;
    ordersLink.tabIndex = show && !searchOpen ? 0 : -1;
    liveLink.tabIndex = show && !searchOpen && !liveLink.hidden ? 0 : -1;
  }
  function schedule() {
    if (!raf) raf = requestAnimationFrame(sync);
  }
  function onScroll() {
    if (idleTimer) clearTimeout(idleTimer);
    idleTimer = setTimeout(function () {
      idleTimer = 0;
      scrollHidden = false;
      direction = 0;
      directionStart = lastY;
      schedule();
    }, idleDelay);
    var y = Math.max(0, window.scrollY || window.pageYOffset || 0);
    var delta = y - lastY;
    lastY = y;
    if (delta) {
      var nextDirection = delta > 0 ? 1 : -1;
      if (nextDirection !== direction) {
        direction = nextDirection;
        directionStart = y - delta;
      }
      if (Math.abs(y - directionStart) >= 10) scrollHidden = nextDirection > 0;
    }
    schedule();
  }

  searchButton.addEventListener('click', function () {
    if (!bar.classList.contains('is-visible')) return;
    if (headerSearchIsOpen()) {
      headerClose.click();
      schedule();
      return;
    }
    if (isBlocked()) return;
    // Execute the original header gesture handler synchronously to retain iOS keyboard activation.
    trigger.click();
    // Only bottom-bar editing on search results retains the displayed query.
    if (query && headerInput && document.documentElement.classList.contains('td-ps-open')) {
      headerInput.value = query;
      headerInput.dispatchEvent(new Event('input', { bubbles: true }));
      try { headerInput.setSelectionRange(query.length, query.length); } catch (e) {}
    }
    schedule();
  });
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', schedule, { passive: true });
  window.addEventListener('pageshow', function () {
    startHints();
    if (idleTimer) clearTimeout(idleTimer);
    idleTimer = 0;
    scrollHidden = false;
    lastY = Math.max(0, window.scrollY || window.pageYOffset || 0);
    directionStart = lastY;
    direction = 0;
    schedule();
  });
  document.addEventListener('predictive-search:open', schedule, true);
  document.addEventListener('predictive-search:close-all', schedule, true);
  document.addEventListener('drawerOpen.CartDrawer', schedule);
  document.addEventListener('drawerClose.CartDrawer', schedule);
  document.addEventListener('visibilitychange', function () {
    if (document.hidden) stopHints();
    else startHints();
    schedule();
  });
  document.addEventListener('focusin', schedule, true);
  document.addEventListener('focusout', schedule, true);
  window.addEventListener('pagehide', function () {
    document.documentElement.classList.remove('td-glass-close-open');
    stopHints();
    if (idleTimer) clearTimeout(idleTimer);
    idleTimer = 0;
    if (noticeHoldTimer) window.clearTimeout(noticeHoldTimer);
    noticeHoldTimer = 0;
  });
  window.addEventListener('td:notice-granted', schedule);
  window.addEventListener('td:notice-released', function () {
    // Existing notices release their token before the ~220ms exit animation finishes.
    noticeHoldUntil = Date.now() + 320;
    if (noticeHoldTimer) window.clearTimeout(noticeHoldTimer);
    noticeHoldTimer = window.setTimeout(function () { noticeHoldTimer = 0; schedule(); }, 330);
    schedule();
  });
  window.addEventListener('td:noFlyRect', schedule);
  if (window.visualViewport) {
    window.visualViewport.addEventListener('resize', schedule, { passive: true });
    window.visualViewport.addEventListener('scroll', schedule, { passive: true });
  }

  // Existing controls change their HTML class; observe only those ownership flags.
  var htmlWatcher = new MutationObserver(schedule);
  htmlWatcher.observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
  var messenger = document.querySelector('[data-td-float-msg]');
  if (messenger) {
    var messengerWatcher = new MutationObserver(schedule);
    messengerWatcher.observe(messenger, { attributes: true, attributeFilter: ['style', 'class'] });
  }
  schedule();
})();
